import React from "react";
import bunnyLogoLight from "~/images/bunnynet-light.svg"
import bunnyLogoDark from "~/images/bunnynet-dark.svg"

const BunnyLogo: React.FC<{ variant: "light" | "dark" }> = ({ variant }) => {
  const bunnyLogo = variant === "dark" ? bunnyLogoDark : bunnyLogoLight;

  return (
    <a className="logo logo--bunny" href="/">
      <img src={bunnyLogo} alt="bunny.net" title="bunny.net" />
    </a>
  )
}

export default BunnyLogo;